"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PROJECT = exports.UPDATE_PROJECT = void 0;
const react_1 = __importStar(require("react"));
const standard_1 = require("react-hook-schema/standard");
const route_1 = require("../route");
const models_hook_1 = require("app/models.hook");
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
const components_1 = require("utils/components");
const js_sha256_1 = require("js-sha256");
const Tabs_1 = __importDefault(require("react-bootstrap/Tabs"));
const Tab_1 = __importDefault(require("react-bootstrap/Tab"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const log_1 = require("common/log");
const standard_2 = require("react-hook-schema/standard");
const translate_prompts_1 = require("translate-prompts");
require("./index.scss");
exports.UPDATE_PROJECT = route_1.PROJECT.sub("/edit", Project);
exports.ADD_PROJECT = route_1.PROJECTS.sub("/edit/new", Project);
function Project({ projectId }) {
    const { projectRole: role } = (0, auth_1.useProjectPageAuthorization)(projectId);
    const isMaster = role === "master";
    const { data, loading, set, isEditing } = (0, models_hook_1.useProjectDoc)({
        projectId,
    });
    const [isPending, setIsPending] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const confirm = (0, standard_1.useConfirm)();
    const errorModal = (0, standard_1.useErrorModal)();
    const alert = (0, standard_1.useAlert)();
    const form = (0, react_hook_form_1.useForm)({
        defaultValues: data,
    });
    const parameter = {
        title: isEditing ? "プロジェクト詳細" : "プロジェクト新規作成",
        schema: {},
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: set,
            path: () => (0, index_1.resolveRoute)("LIST_PROJECTS"),
            isDisabled: !isMaster,
        },
        // clipboard: {
        //   objectType: "project",
        //   retainKeys: ["projectId"],
        // },
        // remove: isEditing ? { handler: remove } : undefined,
    };
    const generateAccessToken = () => {
        const token = (0, js_sha256_1.sha256)(Math.random().toString());
        set(Object.assign(Object.assign({}, data), { accessToken: token }));
    };
    const revokeAccessToken = () => {
        set(Object.assign(Object.assign({}, data), { accessToken: undefined }));
    };
    (0, react_1.useEffect)(() => {
        const currentValue = form.getValues();
        for (const key of currentValue
            ? Object.keys(currentValue)
            : []) {
            if (!data || !(key in data)) {
                form.setValue(key, undefined);
            }
        }
        for (const key of data
            ? Object.keys(data)
            : []) {
            if (currentValue[key] !== data[key]) {
                form.setValue(key, data[key]);
            }
        }
    }, [data]);
    const clickSubmit = (value) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = parameter.edit) === null || _a === void 0 ? void 0 : _a.confirm) !== false) {
            const result = yield confirm({
                message: ((_b = parameter.edit) === null || _b === void 0 ? void 0 : _b.confirm) || "保存しますか？",
            });
            if (!result)
                return;
        }
        try {
            setIsPending(true);
            const record = yield ((_d = (_c = parameter.edit) === null || _c === void 0 ? void 0 : _c.handler) === null || _d === void 0 ? void 0 : _d.call(_c, value));
            const path = typeof ((_e = parameter.edit) === null || _e === void 0 ? void 0 : _e.path) === "function"
                ? parameter.edit.path(record)
                : (_f = parameter.edit) === null || _f === void 0 ? void 0 : _f.path;
            path && navigate(path);
        }
        catch (e) {
            console.error("Error while submit in edit handler", e);
            if (e instanceof Error) {
                alert({ message: e.message });
                (0, log_1.errorLog)(e);
            }
            else {
                errorModal({
                    error: e,
                    userMessage: "更新時のエラーです。通常は発生しないエラーのため、管理者にお問合せください。",
                });
            }
        }
        finally {
            setIsPending(false);
        }
    });
    if (!loading) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.PageHeader, { title: "翻訳ファイル詳細", breadCrumbConfigs: [
                    {
                        name: "プロジェクト一覧",
                        path: (0, index_1.resolveRoute)("LIST_PROJECTS"),
                    },
                    {
                        name: "プロジェクト詳細",
                    },
                ] }),
            react_1.default.createElement("div", { style: { padding: "36px 28px" }, className: "project-detail" },
                react_1.default.createElement(components_1.Card, null,
                    react_1.default.createElement(Tabs_1.default, { defaultActiveKey: "info", variant: "underline" },
                        react_1.default.createElement(Tab_1.default, { eventKey: "info", title: "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u60C5\u5831" },
                            react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form),
                                react_1.default.createElement("form", { onSubmit: form.handleSubmit(clickSubmit) },
                                    react_1.default.createElement("div", { style: { padding: "15px 40px" } },
                                        react_1.default.createElement("p", { className: "mb-3 fw-bold" }, "\u57FA\u672C\u60C5\u5831"),
                                        react_1.default.createElement(standard_2.object, { fieldPath: "", control: form.control, schema: {
                                                schemaType: "object",
                                                properties: [
                                                    {
                                                        title: "プロジェクト名",
                                                        propertyName: "projectName",
                                                        tooltip: "このプロジェクトを表す名前を指定してください",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "text",
                                                            required: true,
                                                        },
                                                    },
                                                    {
                                                        title: "詳細説明",
                                                        propertyName: "description",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "multilineText",
                                                        },
                                                    },
                                                    {
                                                        title: "ロゴ画像",
                                                        propertyName: "logoUrl",
                                                        tooltip: "このプロジェクトのロゴを登録してください",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "image",
                                                            rootPath: projectId
                                                                ? `projects/${projectId}`
                                                                : "images",
                                                            maxHeight: 250,
                                                        },
                                                    },
                                                ],
                                            } })),
                                    react_1.default.createElement(react_bootstrap_1.DropdownDivider, { style: { height: 2 } }),
                                    react_1.default.createElement("div", { style: { padding: "15px 40px" } },
                                        react_1.default.createElement("p", { className: "mb-3 fw-bold" }, "\u30D7\u30ED\u30F3\u30D7\u30C8\u60C5\u5831"),
                                        react_1.default.createElement(standard_2.object, { fieldPath: "", control: form.control, schema: {
                                                schemaType: "object",
                                                properties: [
                                                    {
                                                        title: "翻訳プロンプト（システムプロンプト）",
                                                        propertyName: "translationPrompt.system",
                                                        tooltip: "翻訳用のChatGPTプロンプトを指定します",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "multilineText",
                                                            placeholder: translate_prompts_1.defaultTranslationPrompt.system,
                                                        },
                                                    },
                                                    {
                                                        title: "翻訳プロンプト（ユーザプロンプト）",
                                                        propertyName: "translationPrompt.user",
                                                        tooltip: "翻訳用のChatGPTプロンプトを指定します",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "multilineText",
                                                            placeholder: translate_prompts_1.defaultTranslationPrompt.user,
                                                        },
                                                    },
                                                    {
                                                        title: "校閲プロンプト（システムプロンプト）",
                                                        propertyName: "proofreadingPrompt.system",
                                                        tooltip: "校閲用のChatGPTプロンプトを指定します",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "multilineText",
                                                            placeholder: translate_prompts_1.defaultProofReadingPrompt.system,
                                                        },
                                                    },
                                                    {
                                                        title: "校閲プロンプト（ユーザプロンプト）",
                                                        propertyName: "proofreadingPrompt.user",
                                                        tooltip: "校閲用のChatGPTプロンプトを指定します",
                                                        stacked: true,
                                                        schema: {
                                                            schemaType: "multilineText",
                                                            placeholder: translate_prompts_1.defaultProofReadingPrompt.user,
                                                        },
                                                    },
                                                ],
                                            } }),
                                        react_1.default.createElement(components_1.Button, { type: "submit", disabled: isPending, className: "mt-3" }, isEditing ? "編集" : "作成"))))),
                        react_1.default.createElement(Tab_1.default, { eventKey: "progress", title: "\u9032\u6357\u72B6\u6CC1", disabled: true }),
                        react_1.default.createElement(Tab_1.default, { eventKey: "apiSetting", title: "API\u8A2D\u5B9A" },
                            react_1.default.createElement("div", { style: { padding: "15px 40px" } },
                                react_1.default.createElement(standard_2.object, { control: form.control, fieldPath: "", schema: {
                                        schemaType: "object",
                                        properties: [
                                            {
                                                title: "アクセストークン",
                                                propertyName: "accessToken",
                                                schema: {
                                                    schemaType: "text",
                                                    required: false,
                                                    readOnly: true,
                                                },
                                                stacked: true,
                                            },
                                        ],
                                    } }),
                                react_1.default.createElement("div", { className: "mt-2" },
                                    !data.accessToken && (react_1.default.createElement(components_1.Button, { onClick: generateAccessToken }, "\u30A2\u30AF\u30BB\u30B9\u30C8\u30FC\u30AF\u30F3\u3092\u751F\u6210\u3059\u308B")),
                                    data.accessToken && (react_1.default.createElement(components_1.Button, { onClick: revokeAccessToken, variant: "outline-primary" }, "\u30A2\u30AF\u30BB\u30B9\u30C8\u30FC\u30AF\u30F3\u3092\u5931\u52B9\u3055\u305B\u308B"))))))))));
    }
    else {
        return react_1.default.createElement(components_1.Loading, null);
    }
}
exports.default = Project;
